<script setup>
const props = defineProps({
	btnText: String,
	customStyle: Object,
	customClass: String,
	iconColor: String
})

const emit = defineEmits(['click'])

const handleClick = () => {
	emit('click')
}
</script>

<template>
	<div class="more-button" :class="[ customClass ]" @click="handleClick" :style="{ ...customStyle }">
		<div class="text">{{ btnText }}</div>
		<el-icon
			size="18"
			class="left__more__icon"
			:color="iconColor"
		>
			<Right />
		</el-icon>
	</div>
</template>

<style scoped lang="less">
.more-button {
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 16px 40px;
	border: 1px solid #303133;
	border-radius: 114px;
	font-size: 18px;
	
	.text {
		font-weight: bold;
		margin-right: 10px;
	}
}

@media only screen and (max-width: 768px) {
	.more-button {
		border-radius: 114px;
		padding: 12px 24px;
		font-size: 16px;
		
		.text {
			margin-right: 7px;
		}
	}
}
</style>